/* vendor bundle source omitted; map exists to avoid browser 404 diagnostics. */